// Returns false when the document's Permissions-Policy explicitly denies
// the `camera` feature (e.g. an embedder sends `Permissions-Policy: camera=()`
// or an iframe is missing `allow="camera"`). Falls back to true when the
// browser doesn't expose the feature policy API, so non-Chromium browsers
// keep the existing behaviour.
export const isCameraAvailable = (): boolean => {
  try {
    const doc: any = typeof document !== "undefined" ? document : null;
    const policy = doc && (doc.featurePolicy || doc.permissionsPolicy);
    if (policy && typeof policy.allowsFeature === "function") {
      return policy.allowsFeature("camera");
    }
  } catch (e) {
    // ignore — treat as available
  }
  return true;
};
